import { RefreshIcon } from '@global-engineering-shared/gweb-material-icons-global-next';
import { Typography } from '@global-engineering-shared/gweb-material-ui';

import useStyles from 'features/EntityDetails/components/EntityDetails/EntityDetailTooltip/EntityDetailTooltip.styles';

type EntityDetailTooltipProps = {
  previousEntityLabel: string;
  previousEntityValue: string;
};

const EntityDetailTooltipContent = ({
  previousEntityLabel,
  previousEntityValue,
}: EntityDetailTooltipProps) => {
  const classes = useStyles();

  return (
    <div className={classes.content}>
      <Typography variant="body2" color="textSecondary" fontWeight={400} className={classes.icon}>
        <RefreshIcon data-testid="refresh-icon" />
        <div>{previousEntityLabel}</div>
      </Typography>
      <Typography variant="body2" fontWeight={600}>
        {previousEntityValue}
      </Typography>
    </div>
  );
};

export default EntityDetailTooltipContent;
